import { render } from "./AcademicPerformanceGradesContent.vue?vue&type=template&id=e4340f12&ts=true"
import script from "./AcademicPerformanceGradesContent.vue?vue&type=script&lang=ts"
export * from "./AcademicPerformanceGradesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__